import { Box, Typography } from '@mui/material';

type PromotionalBannerContentProps = {
  variant: 'rate-monitor' | 'account-monitor';
};

export function PromotionalBannerContent({ variant }: PromotionalBannerContentProps) {
  const isRateMonitor = variant === 'rate-monitor';

  const headlineMessagePrefix = isRateMonitor ? 'Put the' : "Don't let your";
  const headlineMessageSuffix = isRateMonitor ? "to work so you don't have to" : 'fall behind';

  const highlightedText = isRateMonitor ? 'Nerds' : 'savings';

  const subheadlineMessage = isRateMonitor
    ? "We'll monitor savings rates and notify you about meaningful changes in the market."
    : "Create a free account, link your bank account, and we'll monitor our marketplace rates for you. When a better rate comes along, you'll be the first to know.";

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        columnGap: {
          xs: '16px',
          md: '8px',
        },
        rowGap: '8px',
        textAlign: {
          xs: 'center',
          md: 'start',
        },
        alignItems: 'flex-start',
      }}
    >
      <Typography
        component="span"
        sx={{
          color: 'text.primary',
          fontSize: '20px',
          width: '100%',
          letterSpacing: '-0.48px',
          flexGrow: 1,
          fontWeight: {
            xs: 600,
            md: 800,
          },
          lineHeight: '104%',
        }}
      >
        {`${headlineMessagePrefix} `}
        <Typography
          component="span"
          sx={{
            color: 'primary.main',
            fontSize: '20px',
            fontWeight: {
              xs: 600,
              md: 800,
            },
            lineHeight: '104%',
          }}
        >
          {highlightedText}
        </Typography>
        {` ${headlineMessageSuffix}`}
      </Typography>
      <Typography
        sx={{
          color: 'text.primary',
          fontSize: '14px',
          fontWeight: 350,
          margin: 0,
          flexGrow: 1,
          lineHeight: '130%',
        }}
      >
        {subheadlineMessage}
      </Typography>
    </Box>
  );
}
